import { GraphQLLocalDate } from '../../../../utils/types';
import { useAppSelector } from '../../../../redux/hooks';
import { bootstrapTimezoneSelector } from '../../../../redux/selectors/bootstrap';
import { globalFormat } from '../../../../utils/formatting';
import TimezonePopup from '../../../TimezonePopup';
import React from 'react';

const DateDisplay = ({ date }: { date: GraphQLLocalDate }) => {
  const timeZone = useAppSelector(bootstrapTimezoneSelector);
  const { dateFormat } = globalFormat.getGlobalFormat();

  return (
    <TimezonePopup
      timestamp={date}
      dateFormat={dateFormat}
      placement="bottom-start"
      showTimezone
      timezone={timeZone}
    />
  );
};

export default DateDisplay;
